import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const teal = '#0D9488'
const plum = '#1E1040'
const cream = '#FAF7F2'

export default function Refunds() {
  useEffect(() => { window.scrollTo(0, 0) }, [])

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <Link to="/" style={styles.back}>← Back</Link>
        <h1 style={styles.h1}>Refund Policy</h1>
        <p style={styles.effective}>Last updated: April 2026</p>

        <p style={styles.lead}>
          We want you to love Merq Log. If it's not the right fit, here's how refunds work —
          plain English, no fine print games.
        </p>

        <h2 style={styles.h2}>14-Day Money-Back Guarantee</h2>
        <p style={styles.p}>
          If you're not satisfied with Merq Log, you can request a full refund within
          <strong> 14 days of your initial subscription purchase</strong>. We'll refund the full
          amount you paid, no questions asked.
        </p>
        <p style={styles.p}>
          To request a refund, email <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a> from the
          email address associated with your account. Include your order number from your Paddle
          receipt if you have it. Refunds are typically processed within 5-7 business days, though
          how long it takes to appear on your statement depends on your bank or card issuer.
        </p>

        <h2 style={styles.h2}>Free Trial</h2>
        <p style={styles.p}>
          Merq Log offers a 14-day free trial with full access to all features. No credit card is
          required to start. If you decide it's not for you during the trial, simply stop using it —
          there's nothing to cancel and no charge.
        </p>

        <h2 style={styles.h2}>Renewal Refunds</h2>
        <p style={styles.p}>
          Annual subscriptions automatically renew each year. We send a renewal reminder email
          before each charge.
        </p>
        <p style={styles.p}>
          <strong>If you forgot to cancel and were charged for a renewal you didn't want, email
          us at <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a> within 14 days of the
          renewal charge and we'll refund it in full.</strong>
        </p>
        <p style={styles.p}>
          Refunds requested more than 14 days after a renewal charge are considered case-by-case
          at our discretion.
        </p>

        <h2 style={styles.h2}>Prorated Refunds</h2>
        <p style={styles.p}>
          We don't offer prorated refunds for partial subscription periods. If you cancel mid-year,
          you keep access until the end of your current billing period, and you won't be charged again.
        </p>

        <h2 style={styles.h2}>Cancellation</h2>
        <p style={styles.p}>
          To cancel your subscription, email <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a>.
          We'll cancel and confirm by email. Cancellation prevents future renewals; it doesn't
          automatically issue a refund. To request a refund, see above.
        </p>

        <h2 style={styles.h2}>How Refunds Are Processed</h2>
        <p style={styles.p}>
          Paddle is the merchant of record for Merq Log subscriptions. Refunds are issued back
          to the original payment method through Paddle. Your bank or card issuer determines how
          long the refund takes to appear on your statement (typically 5-10 business days).
        </p>

        <h2 style={styles.h2}>Disputes</h2>
        <p style={styles.p}>
          If you have a billing concern, please email us first at{' '}
          <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a> before initiating a chargeback.
          We aim to resolve all billing issues quickly and fairly.
        </p>

        <h2 style={styles.h2}>Contact</h2>
        <p style={styles.p}>
          Questions about refunds? Email <a href="mailto:support@getmerq.com" style={styles.link}>support@getmerq.com</a>.
        </p>
        <div style={styles.footer}>
          <Link to="/privacy" style={styles.footerLink}>Privacy Policy</Link>
          <Link to="/terms" style={styles.footerLink}>Terms of Service</Link>
          <Link to="/contact" style={styles.footerLink}>Contact</Link>
        </div>
      </div>
    </div>
  )
}

const styles = {
  page: { minHeight: '100vh', background: cream, fontFamily: "'Plus Jakarta Sans', sans-serif", color: plum, padding: '40px 20px 80px' },
  container: { maxWidth: '760px', margin: '0 auto' },
  back: { color: teal, textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
  h1: { fontFamily: "'Fraunces', serif", fontSize: '40px', fontWeight: 900, letterSpacing: '-1px', margin: '20px 0 8px 0' },
  effective: { fontSize: '13px', color: '#6B7280', fontWeight: 500, marginBottom: '32px' },
  lead: { fontSize: '16px', lineHeight: 1.7, marginBottom: '32px', color: '#374151' },
  h2: { fontFamily: "'Fraunces', serif", fontSize: '24px', fontWeight: 800, letterSpacing: '-0.4px', marginTop: '40px', marginBottom: '14px' },
  p: { fontSize: '15px', lineHeight: 1.65, color: '#374151', marginBottom: '14px' },
  link: { color: teal, fontWeight: 600 },
  address: { fontSize: '14px', lineHeight: 1.7, color: '#374151', background: '#fff', padding: '14px 18px', borderRadius: '10px', border: '1px solid #E5E7EB' },
  footer: { marginTop: '60px', paddingTop: '24px', borderTop: '1px solid #E5E7EB', display: 'flex', gap: '20px', flexWrap: 'wrap' },
  footerLink: { color: teal, textDecoration: 'none', fontSize: '13px', fontWeight: 600 },
}
